import { lazy, Suspense } from 'react';
import { CircularProgress } from '@mui/material';

import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import RoutePrivate from 'components/common/route-private';
import { config } from 'config';

const WebLinks = lazy(() => import('components/GAME_SETTING/webLinks'))
const SettingETC = lazy(() => import('components/GAME_SETTING/etc'))
const SettingELO = lazy(() => import('components/GAME_SETTING/etc/elo'))
const SettingCBB = lazy(() => import('components/GAME_SETTING/etc/cashBounceBack'))
const SettingMaxRewards = lazy(() => import('components/GAME_SETTING/etc/maxRewards'))
const CurrencyMCODE = lazy(() => import('components/GAME_SETTING/mcode'))
const MetaAds = lazy(() => import('components/GAME_SETTING/meta/ads'))
const MetaTimeGift = lazy(() => import('components/GAME_SETTING/meta/timeGift'))
const MetaLevelData = lazy(() => import('components/GAME_SETTING/meta/levels'))
const MetaVip = lazy(() => import('components/GAME_SETTING/meta/vip'))
const RandomBox = lazy(() => import('components/GAME_SETTING/meta/randombox'))
const Items = lazy(() => import('components/GAME_SETTING/meta/items'))
const GameVersion = lazy(() => import('components/GAME_SETTING/gameVersion'))

const GameSetting = () => {
  let { path } = useRouteMatch();

  return (
    <Suspense fallback={<CircularProgress />}>
      <Switch>
        <RoutePrivate exact path={`${path}/weblinks`} component={WebLinks} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/etc`} component={SettingETC} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/elo`} component={SettingELO} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/cbb`} component={SettingCBB} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/maxrewards`} component={SettingMaxRewards} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/mcode`} component={CurrencyMCODE} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/gameversion`} component={GameVersion} permission='VIEWER' />

        <RoutePrivate exact path={`${path}/meta/ads`} component={MetaAds} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/meta/timegift`} component={MetaTimeGift} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/meta/levels`} component={MetaLevelData} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/meta/vip`} component={MetaVip} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/meta/randombox`} component={RandomBox} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/meta/items`} component={Items} permission='VIEWER' />

        <Route path='*'>
          <Redirect to={`/${config.game}/dashboard/notfound`} />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default GameSetting;
